module.exports = __webpack_public_path__ + "static/media/medio-ambiente.15f43bc8.jpg";